import Country from '~/Api/Country/Country';
import RequiredLicenses from '~/Api/DataSource/RequiredLicenses';
import ProductDatasetSource from '~/Api/Product/ProductDatasetSource';

import Dataset from './Dataset';
import mapDatasetExtension, { RawDatasetExtension } from './mapDatasetExtension';

interface RawDataset {
	source: {
		type: string;
		description: string;
		shortName: string;
		country: { alpha2: string; name: string };
		singleUnitPackageSize: boolean;
		requiresLicence: { prices: boolean };
	};
	description: string | null;
	productRetrievedAt: string | null;
	productUpdatedAt: string | null;
	productUrl: string | null;
	validFrom: string | null;
	rawData: { [key: string]: any };
	extensions: RawDatasetExtension[];
}

export default function mapDataset(dataset: RawDataset): Dataset {
	return new Dataset(
		new ProductDatasetSource(
			dataset.source.type,
			dataset.source.description,
			dataset.source.shortName,
			new Country(dataset.source.country.alpha2, dataset.source.country.name),
			dataset.source.singleUnitPackageSize,
			new RequiredLicenses(dataset.source.requiresLicence.prices)
		),
		dataset.description,
		dataset.productRetrievedAt !== null ? new Date(dataset.productRetrievedAt) : null,
		dataset.productUrl,
		dataset.validFrom !== null ? new Date(dataset.validFrom) : null,
		dataset.rawData,
		dataset.productUpdatedAt !== null ? new Date(dataset.productUpdatedAt) : null,
		dataset.extensions.map(mapDatasetExtension)
	);
}
